import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label, dark = false }) => (
  <Reveal className="mb-6 flex items-center gap-4">
    <span
      className={`font-display text-sm font-bold tracking-[0.25em] ${
        dark ? "text-fv-cyan" : "text-fv-blue"
      }`}
    >
      {num}
    </span>
    <span
      className={`h-px w-12 ${dark ? "bg-fv-cyan/50" : "bg-fv-blue/40"}`}
    />
    <span
      className={`text-xs font-semibold uppercase tracking-[0.25em] ${
        dark ? "text-white/70" : "text-fv-navy/60"
      }`}
    >
      {label}
    </span>
  </Reveal>
);

export default Reveal;
